// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__30yqC","title":"Header_title__TQNuW","left":"Header_left__2-9_D","clinicName":"Header_clinicName__2OLR_"};